import { Button } from "@primitives/button";
import { ChevronLeft } from "lucide-react";
import { useNavigationState } from "@/zustand/NavigationState";
import { Input } from "@primitives/input";
import { useState } from "react";
import { useDebounce } from "@uidotdev/usehooks";
import { SEARCH_DEBOUNCE_TIME } from "@/config/constants";

import { useNewGroupChatState } from "@/zustand/NewGroupChatState";

import CreateGroupChatForm from "./CreateGroupChatForm";

import SecondStepButton from "./SecondStepButton";

import SearchedMemberstList from "./SearchedMemberstList";
import { useTranslation } from "react-i18next";

export default function CreateGroupChatView() {
  const { t } = useTranslation();

  const setChatUserAction = useNavigationState(
    (state) => state.setChatUserAction,
  );

  // state values
  const step = useNewGroupChatState((state) => state.step);
  const usernames = useNewGroupChatState((state) => state.usernames);

  // state actions
  const resetNewGroupChatState = useNewGroupChatState(
    (state) => state.resetNewGroupChatState,
  );

  const [searchTerm, setSearchTerm] = useState("");
  const debouncedSearchTerm = useDebounce(searchTerm, SEARCH_DEBOUNCE_TIME);

  const handleBack = () => {
    resetNewGroupChatState();
    setChatUserAction(null);
  };

  if (step === 1) {
    return (
      <div
        id="CreateGroupChatView"
        className="absolute left-0 top-[env(safe-area-inset-top,0px)] flex h-[calc(100%-env(safe-area-inset-top,0px))] w-full flex-col overflow-hidden bg-card lg:top-0 lg:h-full"
      >
        <div className="flex h-leftColumnHeaderHeight shrink-0 items-center border-b border-primary/20 px-4">
          <Button
            className="mr-2"
            size="icon"
            variant="ghost"
            onClick={() => handleBack()}
          >
            <ChevronLeft />
          </Button>

          <div className="flex flex-col">
            <h2 className="truncate text-lg font-semibold leading-tight">
              {usernames.length > 0 ? t("selectMembers") : t("newGroup")}
            </h2>
            {usernames.length > 0 && (
              <h3 className="truncate text-sm font-normal leading-tight text-muted-2">
                {usernames.length + 1} {t("users")}
              </h3>
            )}
          </div>

          <SecondStepButton />
        </div>

        <div className="mt-2 flex px-4 py-1">
          <Input
            defaultValue={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value.toLocaleLowerCase())}
            type="text"
            placeholder={t("whoWouldYouLikeToAdd")}
            className="h-8 bg-foreground/10"
          />
        </div>

        {/* TO DO => EXTRACT in desktop/mobile component */}
        {/* <MemberBadgeList /> */}

        <SearchedMemberstList searchTerm={debouncedSearchTerm} />
      </div>
    );
  }

  return <CreateGroupChatForm />;
}
